import { LDFlagSet, useFlags } from 'launchdarkly-react-client-sdk';
import { useSelector } from 'react-redux';
import { getActiveOrganizationIdSelector } from '@redux/organization/organizationSelectors';

// LaunchDarkly has been decommissioned, so feature flags no longer resolve from a live
// store (they fall back to defaults / stale localStorage). Until a replacement flag source
// exists, the Alzheimer sleep-study UI is turned ON by default for every org, and orgs are
// opted OUT individually via the blacklist below.
//
// `alzheimersSleepStudy` puts the UI into "study mode": the study patient-list columns, the
// dashboard overview tiles, and the Control/Treatment Period fields on the new-patient page.
// It also hides the Manage + engagement-plan tabs (NavTopBar gates them on `!isAlzheimersStudy`).
// If an internal admin org needs those tabs, add its organization id to the opt-out list below
// to keep it in the standard (non-study) UI.
const ALZHEIMERS_STUDY_OPT_OUT_ORG_IDS: readonly string[] = [
  // Add organization ids here to opt an org OUT of study mode (standard UI).
];

/**
 * Drop-in replacement for `useFlags()` that turns Alzheimer study mode on by default for every
 * org, except those in ALZHEIMERS_STUDY_OPT_OUT_ORG_IDS. Live flags are spread first so any that
 * still resolve keep working; the study overrides win. Use this instead of `useFlags()` anywhere
 * an overridden flag is read.
 */
export const useAppFlags = (): LDFlagSet => {
  const activeOrgId = useSelector(getActiveOrganizationIdSelector);
  const studyOverrides: LDFlagSet = ALZHEIMERS_STUDY_OPT_OUT_ORG_IDS.includes(activeOrgId)
    ? {}
    : { alzheimersSleepStudy: true, alzheimersSleepStudyCaregiver: true };
  return { ...useFlags(), ...studyOverrides };
};
